@charset "UTF-8";mat-button-toggle-group{width:100%}mat-button-toggle-group div{width:100%;text-align:left}.swatch{border:1px black solid}.swatch:before{content:"\a0"}
/*# sourceMappingURL=tag-option-items.component.css.map */
